/**
 * Constantes pour les sections du formulaire de quote
 * Source unique de vérité pour les sections
 */

export const FORM_SECTIONS = {
  PERSONAL_INFO: 'personal_info',
  CLIENT_TYPE: 'client_type',
  CLIENT_DETAILS: 'client_details',
  FORMATION_SELECTION: 'formation_selection',
  FORMATION_LOCATION: 'formation_location',
  FORMATION_DETAILS: 'formation_details',
  AVAILABILITY: 'availability',
  FINANCING: 'financing',
  CONSENT: 'consent'
}

/**
 * Noms d'affichage des sections
 */
export const FORM_SECTION_NAMES = {
  [FORM_SECTIONS.PERSONAL_INFO]: 'Informations personnelles',
  [FORM_SECTIONS.CLIENT_TYPE]: 'Type de client',
  [FORM_SECTIONS.CLIENT_DETAILS]: 'Détails client',
  [FORM_SECTIONS.FORMATION_SELECTION]: 'Sélection formation',
  [FORM_SECTIONS.FORMATION_LOCATION]: 'Lieu de formation',
  [FORM_SECTIONS.FORMATION_DETAILS]: 'Détails lieu',
  [FORM_SECTIONS.AVAILABILITY]: 'Disponibilités',
  [FORM_SECTIONS.FINANCING]: 'Financement',
  [FORM_SECTIONS.CONSENT]: 'Consentement',
  unknown: 'Inconnu'
}

/**
 * Nombre total de sections du formulaire
 */
export const TOTAL_FORM_SECTIONS = Object.keys(FORM_SECTIONS).length
